/* shop/BasketAndOrder.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	globals,
	group_outros,
	init,
	insert_dev,
	listen_dev,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	validate_slots,
	validate_store
} from "svelte/internal";

const { console: console_1 } = globals;
import Basket from "./components/Basket.svelte";
import Order from "./components/Order.svelte";
import Summary from "./components/Summary.svelte";
import ThankYou from "./components/ThankYou.svelte";
import basketStore, { basketItemsCount, basketPrice } from "./basketStore";
import orderStore, { isOrderReadyForSubmit } from "./orderStore";
import submitOrder from "./submitOrder";
import { onMount } from "svelte";
const file = "shop/BasketAndOrder.svelte";

// (98:0) {#if display_state == DISPLAY_STATES.BASKET}
function create_if_block_11(ctx) {
	let basket;
	let current;
	basket = new Basket({ $$inline: true });

	const block = {
		c: function create() {
			create_component(basket.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(basket, target, anchor);
			current = true;
		},
		i: function intro(local) {
			if (current) return;
			transition_in(basket.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(basket.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(basket, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_11.name,
		type: "if",
		source: "(98:0) {#if display_state == DISPLAY_STATES.BASKET}",
		ctx
	});

	return block;
}

// (102:0) {#if display_state == DISPLAY_STATES.ORDER}
function create_if_block_10(ctx) {
	let order_1;
	let current;

	order_1 = new Order({
			props: {
				delivery: /*delivery*/ ctx[5],
				paymentMethods: /*paymentMethods*/ ctx[6]
			},
			$$inline: true
		});

	const block = {
		c: function create() {
			create_component(order_1.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(order_1, target, anchor);
			current = true;
		},
		p: noop,
		i: function intro(local) {
			if (current) return;
			transition_in(order_1.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(order_1.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(order_1, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_10.name,
		type: "if",
		source: "(102:0) {#if display_state == DISPLAY_STATES.ORDER}",
		ctx
	});

	return block;
}

// (106:0) {#if display_state == DISPLAY_STATES.SUMMARY}
function create_if_block_9(ctx) {
	let summary;
	let current;
	summary = new Summary({ $$inline: true });

	const block = {
		c: function create() {
			create_component(summary.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(summary, target, anchor);
			current = true;
		},
		i: function intro(local) {
			if (current) return;
			transition_in(summary.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(summary.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(summary, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_9.name,
		type: "if",
		source: "(106:0) {#if display_state == DISPLAY_STATES.SUMMARY}",
		ctx
	});

	return block;
}

// (110:0) {#if display_state == DISPLAY_STATES.THANK_YOU}
function create_if_block_8(ctx) {
	let thankyou;
	let current;

	thankyou = new ThankYou({
			props: { order: /*order*/ ctx[2] },
			$$inline: true
		});

	const block = {
		c: function create() {
			create_component(thankyou.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(thankyou, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const thankyou_changes = {};
			if (dirty & /*order*/ 4) thankyou_changes.order = /*order*/ ctx[2];
			thankyou.$set(thankyou_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(thankyou.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(thankyou.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(thankyou, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_8.name,
		type: "if",
		source: "(110:0) {#if display_state == DISPLAY_STATES.THANK_YOU}",
		ctx
	});

	return block;
}

// (116:4) {#if display_state == DISPLAY_STATES.BASKET}
function create_if_block_6(ctx) {
	let if_block_anchor;
	let if_block = /*$basketItemsCount*/ ctx[3] > 0 && create_if_block_7(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (/*$basketItemsCount*/ ctx[3] > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_7(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_6.name,
		type: "if",
		source: "(116:4) {#if display_state == DISPLAY_STATES.BASKET}",
		ctx
	});

	return block;
}

// (118:8) {#if $basketItemsCount > 0}
function create_if_block_7(ctx) {
	let button;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			button = element("button");
			button.textContent = "Pokračovat";
			attr_dev(button, "class", "basketButton");
			attr_dev(button, "type", "button");
			add_location(button, file, 118, 12, 3247);
		},
		m: function mount(target, anchor) {
			insert_dev(target, button, anchor);

			if (!mounted) {
				dispose = listen_dev(button, "click", /*click_handler*/ ctx[9], false, false, false, false);
				mounted = true;
			}
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(button);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_7.name,
		type: "if",
		source: "(118:8) {#if $basketItemsCount > 0}",
		ctx
	});

	return block;
}

// (127:4) {#if display_state == DISPLAY_STATES.ORDER}
function create_if_block_3(ctx) {
	let if_block_anchor;
	let if_block = /*$basketItemsCount*/ ctx[3] > 0 && create_if_block_4(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (/*$basketItemsCount*/ ctx[3] > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_4(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(127:4) {#if display_state == DISPLAY_STATES.ORDER}",
		ctx
	});

	return block;
}

// (128:8) {#if $basketItemsCount > 0}
function create_if_block_4(ctx) {
	let button;
	let t1;
	let if_block_anchor;
	let mounted;
	let dispose;
	let if_block = /*$isOrderReadyForSubmit*/ ctx[4] && create_if_block_5(ctx);

	const block = {
		c: function create() {
			button = element("button");
			button.textContent = "Zpět";
			t1 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			attr_dev(button, "class", "basketButton basketButton__rev");
			attr_dev(button, "type", "button");
			add_location(button, file, 129, 12, 3593);
		},
		m: function mount(target, anchor) {
			insert_dev(target, button, anchor);
			insert_dev(target, t1, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);

			if (!mounted) {
				dispose = listen_dev(button, "click", /*click_handler_1*/ ctx[10], false, false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (/*$isOrderReadyForSubmit*/ ctx[4]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_5(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(button);
			if (detaching) detach_dev(t1);
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(128:8) {#if $basketItemsCount > 0}",
		ctx
	});

	return block;
}

// (135:12) {#if $isOrderReadyForSubmit}
function create_if_block_5(ctx) {
	let button;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			button = element("button");
			button.textContent = "Pokračovat";
			attr_dev(button, "class", "basketButton");
			attr_dev(button, "type", "button");
			add_location(button, file, 135, 16, 3874);
		},
		m: function mount(target, anchor) {
			insert_dev(target, button, anchor);

			if (!mounted) {
				dispose = listen_dev(button, "click", /*click_handler_2*/ ctx[11], false, false, false, false);
				mounted = true;
			}
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(button);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_5.name,
		type: "if",
		source: "(135:12) {#if $isOrderReadyForSubmit}",
		ctx
	});

	return block;
}

// (145:4) {#if display_state == DISPLAY_STATES.SUMMARY}
function create_if_block_1(ctx) {
	let if_block_anchor;
	let if_block = /*$basketItemsCount*/ ctx[3] > 0 && /*$isOrderReadyForSubmit*/ ctx[4] && create_if_block_2(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_dev(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (/*$basketItemsCount*/ ctx[3] > 0 && /*$isOrderReadyForSubmit*/ ctx[4]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(145:4) {#if display_state == DISPLAY_STATES.SUMMARY}",
		ctx
	});

	return block;
}

// (146:8) {#if $basketItemsCount > 0 && $isOrderReadyForSubmit}
function create_if_block_2(ctx) {
	let button0;
	let t1;
	let button1;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			button0 = element("button");
			button0.textContent = "Zpět";
			t1 = space();
			button1 = element("button");
			button1.textContent = "Závazně objednat";
			attr_dev(button0, "class", "basketButton basketButton__rev");
			attr_dev(button0, "type", "button");
			add_location(button0, file, 147, 12, 4284);
			attr_dev(button1, "class", "basketButton");
			attr_dev(button1, "type", "button");
			add_location(button1, file, 152, 12, 4513);
		},
		m: function mount(target, anchor) {
			insert_dev(target, button0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, button1, anchor);

			if (!mounted) {
				dispose = [
					listen_dev(button0, "click", /*click_handler_3*/ ctx[12], false, false, false, false),
					listen_dev(button1, "click", /*click_handler_4*/ ctx[13], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(button0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(button1);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(146:8) {#if $basketItemsCount > 0 && $isOrderReadyForSubmit}",
		ctx
	});

	return block;
}

// (163:0) {#if showWait}
function create_if_block(ctx) {
	let div;

	const block = {
		c: function create() {
			div = element("div");
			div.textContent = "přijímáme objednávku...";
			attr_dev(div, "class", "wait svelte-9fao4y");
			add_location(div, file, 163, 4, 4766);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(163:0) {#if showWait}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div1;
	let t0;
	let t1;
	let t2;
	let t3;
	let div0;
	let t4;
	let t5;
	let t6;
	let current;
	let if_block0 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].BASKET && create_if_block_11(ctx);
	let if_block1 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].ORDER && create_if_block_10(ctx);
	let if_block2 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].SUMMARY && create_if_block_9(ctx);
	let if_block3 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].THANK_YOU && create_if_block_8(ctx);
	let if_block4 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].BASKET && create_if_block_6(ctx);
	let if_block5 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].ORDER && create_if_block_3(ctx);
	let if_block6 = /*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].SUMMARY && create_if_block_1(ctx);
	let if_block7 = /*showWait*/ ctx[1] && create_if_block(ctx);

	const block = {
		c: function create() {
			div1 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			t2 = space();
			if (if_block3) if_block3.c();
			t3 = space();
			div0 = element("div");
			if (if_block4) if_block4.c();
			t4 = space();
			if (if_block5) if_block5.c();
			t5 = space();
			if (if_block6) if_block6.c();
			t6 = space();
			if (if_block7) if_block7.c();
			attr_dev(div0, "class", "basketButtonWrap");
			add_location(div0, file, 113, 0, 3060);
			attr_dev(div1, "class", "container basket");
			add_location(div1, file, 95, 0, 2689);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div1, anchor);
			if (if_block0) if_block0.m(div1, null);
			append_dev(div1, t0);
			if (if_block1) if_block1.m(div1, null);
			append_dev(div1, t1);
			if (if_block2) if_block2.m(div1, null);
			append_dev(div1, t2);
			if (if_block3) if_block3.m(div1, null);
			append_dev(div1, t3);
			append_dev(div1, div0);
			if (if_block4) if_block4.m(div0, null);
			append_dev(div0, t4);
			if (if_block5) if_block5.m(div0, null);
			append_dev(div0, t5);
			if (if_block6) if_block6.m(div0, null);
			append_dev(div1, t6);
			if (if_block7) if_block7.m(div1, null);
			current = true;
		},
		p: function update(ctx, [dirty]) {
			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].BASKET) {
				if (if_block0) {
					if (dirty & /*display_state*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_11(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div1, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].ORDER) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*display_state*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_10(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].SUMMARY) {
				if (if_block2) {
					if (dirty & /*display_state*/ 1) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_9(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div1, t2);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].THANK_YOU) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty & /*display_state*/ 1) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_8(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(div1, t3);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].BASKET) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_6(ctx);
					if_block4.c();
					if_block4.m(div0, t4);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].ORDER) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_3(ctx);
					if_block5.c();
					if_block5.m(div0, t5);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (/*display_state*/ ctx[0] == /*DISPLAY_STATES*/ ctx[7].SUMMARY) {
				if (if_block6) {
					if_block6.p(ctx, dirty);
				} else {
					if_block6 = create_if_block_1(ctx);
					if_block6.c();
					if_block6.m(div0, null);
				}
			} else if (if_block6) {
				if_block6.d(1);
				if_block6 = null;
			}

			if (/*showWait*/ ctx[1]) {
				if (if_block7) {
					
				} else {
					if_block7 = create_if_block(ctx);
					if_block7.c();
					if_block7.m(div1, null);
				}
			} else if (if_block7) {
				if_block7.d(1);
				if_block7 = null;
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block3);
			current = true;
		},
		o: function outro(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block3);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div1);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			if (if_block7) if_block7.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	let $basketPrice;
	let $basketStore;
	let $basketItemsCount;
	let $isOrderReadyForSubmit;
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(14, $orderStore = $$value));
	validate_store(basketPrice, 'basketPrice');
	component_subscribe($$self, basketPrice, $$value => $$invalidate(15, $basketPrice = $$value));
	validate_store(basketStore, 'basketStore');
	component_subscribe($$self, basketStore, $$value => $$invalidate(16, $basketStore = $$value));
	validate_store(basketItemsCount, 'basketItemsCount');
	component_subscribe($$self, basketItemsCount, $$value => $$invalidate(3, $basketItemsCount = $$value));
	validate_store(isOrderReadyForSubmit, 'isOrderReadyForSubmit');
	component_subscribe($$self, isOrderReadyForSubmit, $$value => $$invalidate(4, $isOrderReadyForSubmit = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('BasketAndOrder', slots, []);
	const dataElm = document.getElementById("basketAndOrder");
	const delivery = JSON.parse(dataElm.dataset.delivery);
	const paymentMethods = JSON.parse(dataElm.dataset.paymentMethods);

	// stav zobrazeni
	const DISPLAY_STATES = {
		BASKET: "BASKET",
		ORDER: "ORDER",
		SUMMARY: "SUMMARY",
		THANK_YOU: "THANK_YOU"
	};

	let display_state = DISPLAY_STATES.BASKET;

	// zobrazeni "wait" divu
	let showWait = false;

	// objekt objednavky (vraceny po ulozeni)
	let order = null;

	// odeslani objednavky
	const handleSubmitOrder = () => {
		// odeslat objednavku do API
		// zobrazeni wait
		$$invalidate(1, showWait = true);

		// sestaveni dat
		const data = {
			...$orderStore,
			items: $basketStore.items,
			basketPrice: $basketPrice + $orderStore.price_delivery + $orderStore.price_payment
		};

		// odeslani
		submitOrder(
			data,
			// success callback
			xhr => {
				basketStore.clean();
				$$invalidate(2, order = JSON.parse(xhr.responseText));
				$$invalidate(0, display_state = DISPLAY_STATES.THANK_YOU);
				$$invalidate(1, showWait = false);
			},
			// error callback
			xhr => {
				alert('Je nám líto, ale nepodařilo se přijmout objednávku.');
				$$invalidate(1, showWait = false);
			}
		);
	};

	onMount(async () => {
		fetch('/api/shop/discount', {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		}).then(response => response.json()).then(data => {
			data = JSON.parse(data);
			basketStore.initDiscount(data.quantityThreshold, data.unitDiscount, new Date(data.startDate), new Date(data.endDate));
		}).catch(error => {
			console.error('Error:', error);
		});
	});

	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console_1.warn(`<BasketAndOrder> was created with unknown prop '${key}'`);
	});

	const click_handler = () => $$invalidate(0, display_state = DISPLAY_STATES.ORDER);
	const click_handler_1 = () => $$invalidate(0, display_state = DISPLAY_STATES.BASKET);
	const click_handler_2 = () => $$invalidate(0, display_state = DISPLAY_STATES.SUMMARY);
	const click_handler_3 = () => $$invalidate(0, display_state = DISPLAY_STATES.ORDER);
	const click_handler_4 = () => handleSubmitOrder();

	$$self.$capture_state = () => ({
		Basket,
		Order,
		Summary,
		ThankYou,
		basketStore,
		basketItemsCount,
		basketPrice,
		orderStore,
		isOrderReadyForSubmit,
		submitOrder,
		onMount,
		dataElm,
		delivery,
		paymentMethods,
		DISPLAY_STATES,
		display_state,
		showWait,
		order,
		handleSubmitOrder,
		$orderStore,
		$basketPrice,
		$basketStore,
		$basketItemsCount,
		$isOrderReadyForSubmit
	});

	$$self.$inject_state = $$props => {
		if ('display_state' in $$props) $$invalidate(0, display_state = $$props.display_state);
		if ('showWait' in $$props) $$invalidate(1, showWait = $$props.showWait);
		if ('order' in $$props) $$invalidate(2, order = $$props.order);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [
		display_state,
		showWait,
		order,
		$basketItemsCount,
		$isOrderReadyForSubmit,
		delivery,
		paymentMethods,
		DISPLAY_STATES,
		handleSubmitOrder,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4
	];
}

class BasketAndOrder extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "BasketAndOrder",
			options,
			id: create_fragment.name
		});
	}
}

export default BasketAndOrder;